import { CommandTemplate } from '../commandTemplate/commandTemplate';
import { HasCommands } from '../../services/command/command.service';

export class Trigger implements HasCommands {

  static ENTITY_TYPE: string = 'Trigger';

  key: { name: string; group: string };
  nextFireTime: string | null;
  previousFireTime: string | null;
  triggerState: string;
  commands: CommandTemplate[];

  constructor(payload?: any) {
    if (payload) {
      this.key = payload.key;
      this.nextFireTime = payload.nextFireTime ?? null;
      this.previousFireTime = payload.previousFireTime ?? null;
      this.triggerState = payload.triggerState;
      this.commands = (payload.commands ?? []).map((command: any) => new CommandTemplate(command));
    }
  }

  getEntityType(): string {
    return Trigger.ENTITY_TYPE;
  }

  getEntityId(): string {
    return this.key ? `${this.key.group}/${this.key.name}` : undefined;
  }

  /** Trigger hat keine eigene Liste — nur im Job-Detail sichtbar (siehe Spec §13). */
  getCollectionRoute(): string {
    return undefined;
  }
}
